import React from 'react';
import { Check } from '@styled-icons/bootstrap/Check';
import styled from 'styled-components';
const List = styled.ul `
  padding: 0;
  margin: 0;
`;
const Item = styled.ul `
  display: flex;
  grid-gap: 15px;
  margin: 0;
  padding: 13px 0;
  border-bottom: 1px solid ${({ theme }) => theme.palette.grey['200']};
  font-size: 14px;
`;
const CheckList = ({ items }) => {
    return (React.createElement(List, null, items.map((text) => (React.createElement(Item, { key: text },
        React.createElement("div", null,
            React.createElement(Check, { size: 25 })),
        React.createElement("span", null, text))))));
};
export default CheckList;
